export const logger = window?.emui?.logger || console;
